var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8917 5V6.99999C18.798 6.99999 21.976 10.1405 21.976 14C21.976 17.8595 18.7978 21.0001 14.8917 21.0001C10.9855 21.0001 7.80733 17.8592 7.80733 14H10.5906L6.79541 8.99993L3 14H5.7833C5.7833 18.9629 9.86956 23 14.8917 23C19.9138 23 24 18.9627 24 14C24 9.03732 19.9137 5.00005 14.8917 5.00005V5Z",
    fill: "#C9EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 17.2381L14.2974 14.1638V9H13V14.6101L17.0827 18L18 17.2381Z",
    fill: "#C9EFFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewBlue);
export default __webpack_public_path__ + "static/media/Review-blue.169287d4051c104fb60573f2f8ab1d05.svg";
export { ForwardRef as ReactComponent };